import { Avatar } from "@heroui/react";
import React, { useEffect, useState } from "react";
import { DocumentIcon, TriangleIcon } from "../../assets/icons";
import axiosInstance from "../../redux/network/https";
import { endPoints } from "../../redux/network/constant";
import { COLORS } from "../../constants/colors";

const AttachementMessage = ({
  name,
  avatar,
  messageTime,
  me,
  chatType,
  fileType,
  attachements,
  completeItem,
}) => {
  const [signedUrl, setSignedUrl] = useState("");

  useEffect(() => {
    if (!attachements?.s3_key || !completeItem?.channel_id) return;
    axiosInstance.post(endPoints.ChatAttachmentDownloadUrl, {
      channel_id: completeItem.channel_id,
      s3_key: attachements.s3_key,
    }).then((response) => setSignedUrl(response?.data?.data?.download_url || "")).catch(() => setSignedUrl(""));
  }, [attachements?.s3_key, completeItem?.channel_id]);

  const openFile = (url) => {
    if (!url) return;
    window.open(url, "_blank");
  };
  const attachmentUnavailable = Boolean(attachements && !attachements?.s3_key);

  return (
    <div className={`${chatType === "group" ? "pb-1" : ""}`}>
      {/* Message Container */}
      {!me && chatType === "group" && (
        // Avatar is display-only here: handleAvatarClick no-ops for group chats.
        <span className="w-6 !-mt-2">
          <Avatar
            src={avatar}
            name={name?.slice(0, 1)?.toLocaleUpperCase() + name?.split(" ")?.[1]?.slice(0, 1)?.toLocaleUpperCase()}
            className="w-6 h-6 text-xs bg-opacity-65 bg-surface0"
            classNames={{
              base: "bg-mediumgrey/30",
              icon: "text-black/60",
            }}
          />
        </span>
      )}
      <div
        className={`relative h-full px-2 pt-3 rounded-lg  ${me ? "bg-chat-user pb-4" : `pb-2 bg-chat-assistant left-2.5 ${chatType === "group" && "ml-6 -top-3"}`
          }`}
      >
        {attachmentUnavailable ? <p className={`text-sm ${me ? "text-white" : "text-danger"}`}>Attachment unavailable</p> : null}
        {!attachmentUnavailable && (fileType === "image" || fileType === "video") ? (
          <React.Fragment>
            {/* images / video */}
            <div
              className={`w-full h-[200px] rounded-md bg-primary ${me ? "mb-2" : `${chatType === "group" ? "-mb-2 min-w-[200px]" : "mb-4 min-w-[240px]"}`
                }`}
            >
              {fileType === "image" ? (
                <img
                  className="w-full h-full object-contain cursor-pointer"
                  src={signedUrl}
                  alt={attachements?.file_name || ""}
                  onClick={() => openFile(signedUrl)}
                />
              ) : fileType === "video" ? (
                <video className="w-full h-full object-contain rounded-md" controls>
                  <source src={signedUrl} type="video/mp4" />
                  <track kind="captions" />
                </video>
              ) : null}
            </div>

            {/* Message */}
            {/* <p className='float-left h-full text-sm pb-4 !min-w-20 pr-8 ${me ? 'text-white' : 'text-black'}'>
                        {message}
                    </p> */}
            {/* Message Date*/}
            <span className={`absolute right-3 bottom-1 text-xs ${me ? "text-white" : "text-chat-muted"} leading-none`}>
              {messageTime ? messageTime : ""}
            </span>
          </React.Fragment>
        ) : (
          // Audio/Document
          <React.Fragment>
            {fileType === "audio" ? (
              <audio className="w-full h-full object-contain" controls>
                  <source src={signedUrl} type="audio/mpeg" />
                  <track kind="captions" />
              </audio>
            ) : fileType === "document" ? (
              <div className="">
                <div
                  className={`w-full h-8 flex items-center justify-between gap-2 px-3 py-1 ${me ? "mb-4" : `${chatType !== "group" && "!pt-4 !pb-10"}`
                    } cursor-pointer`}
                  onClick={() => openFile(signedUrl)}
                >
                  <span
                    className={`${me ? "text-white" : "text-chat-muted"} ${chatType === "group" ? "max-w-[48vw]" : "max-w-[55vw]"
                      } underline truncate`}
                  >
                    {attachements?.file_name}
                  </span>
                  <span className="w-10 h-10">
                    <DocumentIcon className="w-10 h-10" />
                  </span>
                </div>
              </div>
            ) : null}
            {/* Message Date*/}
            <span
              className={`absolute right-1.5 bottom-1.5 text-xs ${me ? "text-white" : "text-chat-muted"} leading-none`}
            >
              {messageTime ? messageTime : ""}
            </span>
          </React.Fragment>
        )}
        {/* Triangle */}
        {!me ? (
          <span>
            <TriangleIcon className={"rotate-[60deg] absolute top-[-5px] -left-1.5"} color={COLORS.chatAssistant} />
          </span>
        ) : (
          <span>
            <TriangleIcon className={"-rotate-[60deg] absolute -top-[5px] -right-1.5"} color={COLORS.chatUser} />
          </span>
        )}
      </div>
    </div>
  );
};

export default AttachementMessage;
